/* eslint-disable no-shadow */
export enum B2BUserScreens {
  OrderInfo = 'OrderInfo',
  ShopperInfo = 'ShopperInfo',
  OrderItemInfo = 'OrderItemInfo',
  UserLogin = 'UserLogin',
  Reschedule = 'Reschedule',
}

export enum B2BScreens {
  B2BCheckout = 'B2BCheckout',
  B2BBarcode = 'B2BBarcode',
  B2BOrderInfo = 'B2BOrderInfo',
}
